import { useNavigate } from 'react-router-dom-v6'

import { ConfigTemplateWizard } from '../components/ConfigTemplateWizard'
import { useRegisterConfigTemplate } from '../hooks'
import { formValuesToTemplate } from '../transforms'
import type { ConfigTemplate, ConfigTemplateFormValues } from '../types'

export function RegisterConfigTemplate() {
  const navigate = useNavigate()
  const { mutateAsync: register } = useRegisterConfigTemplate()

  const onSubmit = async (values: ConfigTemplateFormValues) => {
    await register(formValuesToTemplate(values) as ConfigTemplate)
    navigate('/config-templates')
  }

  return <ConfigTemplateWizard onSubmit={onSubmit} />
}
